// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__UJYrW","itemTitle":"ClientEmergencyInfo_itemTitle__2ZgsP","itemText":"ClientEmergencyInfo_itemText__15n8y"};